import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";

import { DarkHome } from "@/pages/DarkHome";
import { LightHome } from "@/pages/LightHome";
import { CityPage } from "@/pages/CityPage";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LightHome />} />
          <Route path="/etancheite/:city" element={<CityPage />} />
          <Route path="/v2" element={<DarkHome />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
